/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_ScheduleInputs */

const en_features_desk_schedule = /** @type {(inputs: Features_Desk_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

const pl_features_desk_schedule = /** @type {(inputs: Features_Desk_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Features_Desk_ScheduleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_schedule = /** @type {((inputs?: Features_Desk_ScheduleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_ScheduleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_schedule(inputs)
	return en_features_desk_schedule(inputs)
});